<template>
  <div style="margin-top:20px;" class="cart-wrap">
      <div class="span" style="width: 100%;text-align: center;padding-top: 100px;" v-show="emptyFlag">暂无需付定金订单</div>
      <div class="cart-info" style="width: 100%;text-align: center;" v-show="titleFlag">
          <span class="span">定金单明细</span>
          <div class="cart-info-wrap" v-for="(preSaleOrderMainVO, index) in preSaleOrderMainVOList" :key="index">
              <b-row class="order-info">
                  <b-col style="display:flex;justify-content: flex-start;font-weight: bold;">
                      交货日期：{{preSaleOrderMainVO.sendProductDate}}({{preSaleOrderMainVO.weekSeq}}周)
                  </b-col>
                  <b-col style="display:flex;justify-content: flex-end;font-weight: bold;">
                      收货地址：{{preSaleOrderMainVO.receiptFullAddress}}</b-col>
              </b-row>
              <b-table id="sales-cart-table" :fields="salesCart.fields" :items="preSaleOrderMainVO.orderItmeList"
                  small bordered hover show-empty empty-text="没有找到匹配的记录" :busy="salesCart.isTableBusy" caption-top>
        <template v-slot:cell(index)="row">
          <template v-if="row.item.productCode==''||row.item.productCode=='定金收取(%)'">
            <span></span>
          </template>
          <template v-else>
              {{ row.index + 1 }}
          </template>
        </template>
        <template v-slot:cell(productName)="row">
          <template v-if="row.item.productCode=='定金收取(%)'">
            <input @input="changeProductName($event,row.item)" type="number" v-model="row.item.productName" style="font-size: 24rpx;border: 1px solid #666;height: 52rpx;text-align: center;" min="20" max="100" />
          </template>
          <template v-else>
            {{row.item.productName}}
          </template>
        </template>
            <template v-slot:cell(orderQuantity)="row">
          <template v-if="row.item.depositBillDetailUuid||row.item.unitName=='数量合计'">
                {{parseFloat(row.item.orderQuantity)}}
          </template>
          <template v-else>
              {{row.item.orderQuantity}}
          </template>
        </template>
        <template v-slot:cell(totalMoney)="row">
          <template v-if="row.item.productCode=='定金收取(%)'">
            <input @input="changeTotalMoney($event,row.item)" type="number" v-model="row.item.totalMoney" style="font-size: 24rpx;border: 1px solid #666;height: 52rpx;text-align: center;" min="0" />
          </template>
          <template v-else-if="row.item.productName=='折扣'||row.item.preSalePlanPrice=='总额'">
      		 <span>{{ parseFloat(row.item.totalMoney.toFixed(2)) }}</span>
          </template>
          <template v-else>
            {{row.item.totalMoney}}
          </template>
        </template>
              </b-table>
              <b-form class="order-pro-list" style="margin-bottom: 3px;">
                  <b-button size="sm" type="success" variant="success" v-on:click="showContract(preSaleOrderMainVO)">
                      查看种苗定购协议
                  </b-button>
                  <b-form-text class="bf-text">小计金额:<span
                          class="red-color">{{parseFloat(preSaleOrderMainVO.totalFee .toFixed(2))}}元</span>
                  </b-form-text>
              </b-form>
      <div class="input-group" style="margin-bottom: 20px;">
          <div class="input-group-prepend">
              <span class="input-group-text " style="height: 40px ;">客户备注:</span>
          </div>
          <textarea v-model="preSaleOrderMainVO.customerMsg" autocomplete="off" style="height: 40px ;" class="form-control" aria-label="With textarea" placeholder="请输入订单备注(选填)"></textarea>
      </div>
          </div>

          <div v-show="allFlag">
              <b-row class="bottom-card">
                  <b-col style="display:flex;justify-content: flex-start;">
                      <b-form class="order-pro-list">
                          <b-form-text class="bf-text">待付总金额：<span class="red-color">{{totalMainMoney.toFixed(2)}}元</span>
                          </b-form-text>
                      </b-form>
                  </b-col>
                  <b-col style="display:flex;justify-content: flex-end;">
                      <div class="btns">
                          <b-button size="sm" variant="warning" v-if="isShowDeposit" v-on:click="payDeposit()">
                              支付定金
                          </b-button>
                          <b-button size="sm" variant="danger" v-on:click="payTotalFee()">
                              全额支付
                          </b-button>
                      </div>
                  </b-col>
              </b-row>
          </div>
      </div>
  </div>
</template>

<script>
  import api from "@/api/api";
  import search from '@/libs/search';
  import HttpRequest from '@/libs/axios';
  import {
      formatDateTimeString,
      numberToFixed
  } from "@/libs/utils";
  export default {
      name: "Cart",
      data() {
          return {
              totalMainCount: 0,
              totalMainMoney: 0,
              allChecked: false,
              indeterminate: false,
              emptyFlag: false,
              titleFlag: true,
              allFlag: true,
              showAddressList: false,
              addressInfo: {},
              preSaleOrderMainVOList: {},
              depositBillRecordUuidArray: [],
      depositValueArray:[],
      customerMsg:null,
      customerMsgArray:[],
              salesCart: {
                  items: [],
                  isTableBusy: false,
                  fields: [
          {
              key: "index",
              label: "序号"
          },
          {
                          key: "productCode",
                          label: "品种编码"
                      },
                      {
                          key: "productName",
                          label: "品种名称"
                      },
                       {
                          key: "unitName",
                          label: "单位"
                      },
                      {
                          key: "orderQuantity",
                          label: "数量"
                      },                 
                      {
                          key: "preSalePlanPrice",
                          label: "单价"
                      },
                      {
                          key: "totalMoney",
                          label: "金额"
                      }
                  ],
                  orderForm: {
                      itemFee: 0,
                      showSubmitSpin: false,
                  },
                  isCheckContract: false
              },
              clickRepeat:false
          }
      },
      mounted() {
          if (!this.checkMemberLogin()) {
              this.$router.push({
                  name: "MemberLogin"
              });
              return;
          };
          if (this.$route.query.sendProductDateArray) {
              let sendProductDateArray = JSON.parse(decodeURIComponent(this.$route.query.sendProductDateArray));
               let depositUuidArray;
              if(this.$route.query.depositUuids){
                depositUuidArray = JSON.parse(decodeURIComponent(this.$route.query.depositUuids));
              }
                console.log(depositUuidArray);

              let depositBillRecordUuid= this.$route.query.depositBillRecordUuid? this.$route.query.depositBillRecordUuid:"没有传定金单Id";
              console.log(depositBillRecordUuid);
              this.getAppPreSaleOrderList(sendProductDateArray,depositUuidArray)
          }

          this.getUserAddressInfo();
      },
      computed: {
        isShowDeposit(){
            //如果明细列表中有定金等于小计的就全款支付，不显示支付定金按钮
           let result= this.preSaleOrderMainVOList.some(x=>x.productDepositValue==x.productPriceActual);
            return !result;
        }
      },
      methods: {
    changeProductName(row){
      let totalMoney=0;
      let depositMoney=0;
      this.preSaleOrderMainVOList.forEach(obj =>{
        obj.orderItmeList.forEach(item =>{
          if(item.preSalePlanPrice=='金额合计'){
            totalMoney=item.totalMoney;
          }
        });
      });
      this.preSaleOrderMainVOList.forEach(obj =>{
        obj.orderItmeList.forEach(item =>{
          if(item.preSalePlanPrice=='定金'){
            depositMoney=parseFloat((totalMoney*item.productName/100).toFixed(3));
          }
        });
      });
      this.preSaleOrderMainVOList.forEach(obj =>{
          obj.orderItmeList.forEach(item =>{
          if(item.preSalePlanPrice=='定金'){
            item.totalMoney=depositMoney;
          }
        });
      });
    },
    changeTotalMoney(row){
      let totalMoney=0;
      let depositValue=0;
      this.preSaleOrderMainVOList.forEach(obj =>{
        obj.orderItmeList.forEach(item =>{
          if(item.preSalePlanPrice=='金额合计'){
            totalMoney=item.totalMoney;
          }
        });
      });
      this.preSaleOrderMainVOList.forEach(obj =>{
        obj.orderItmeList.forEach(item =>{
          if(item.preSalePlanPrice=='定金'){
            depositValue=parseFloat(((item.totalMoney/totalMoney)*100).toFixed(3));
          }
        });
      });
      this.preSaleOrderMainVOList.forEach(obj =>{
          obj.orderItmeList.forEach(item =>{
          if(item.preSalePlanPrice=='定金'){
            item.productName=depositValue;
          }
        });
      });
    },
          confirmAddress(address) {
              this.addressInfo = address;
              //将用户外键表的关联收货地址改为当前选中的
              if (this.preSaleOrderMainVOList.length == 0) {
                  return;
              }
              let arrayUuid = [];
              this.preSaleOrderMainVOList.forEach((item) => {
                  arrayUuid.push(item.preSaleOrderRecordUuid);
              });
              api.getUserAddressInfo({
                  addressId: address.memberDeliveryAddressUuid,
                  preSaleOrderRecordUuidArray: arrayUuid
              }).then(res => {
                  if (res.code === 0) {
                      this.preSaleOrderMainVOList.map(preSaleOrderMainVO => {
                          preSaleOrderMainVO.receiptFullAddress = res.data.receiptFullAddress;
                      });
                      this.addressInfo.memberDeliveryAddressContacts = address.memberDeliveryAddressContacts;
                      this.addressInfo.memberDeliveryAddressPhone = address.memberDeliveryAddressPhone;
                      this.addressInfo.memberDeliveryAddressFull = address.memberDeliveryAddressFull;

                      this.showAddressList = false;
                  }
              });
          },
          replaceStr(dateStr) {
              if (dateStr != null && dateStr != '') {
                  return dateStr.replace('年', '-').replace('月', '-').replace('日', '');
              }
              return '';
          },
          onClose(e) {},
          getUserAddressInfo() {
              let address = this.getAddressInfo();
              if (address) {
                  this.addressInfo = address;
              }
          },
          // 获取待付列表
          getAppPreSaleOrderList(sendProductDate,depositUuidArray) {
              this.salesCart.isTableBusy = true;
              api.getUserDepositBillInfoList({
                  sendProductDateArray: sendProductDate,
                  paidStatus: '未支付',
                  isSign: 1
              }).then(res => {
                  this.salesCart.isTableBusy = false;
                  if (res.code === 0) {
                      if (res.data.depositBillMainVOList != null && res.data.depositBillMainVOList.length >
                          0) {
                          this.preSaleOrderMainVOList = res.data.depositBillMainVOList;

                          if(depositUuidArray&&depositUuidArray.length>0){
                             this.preSaleOrderMainVOList= this.preSaleOrderMainVOList.filter(x=>depositUuidArray.includes(x.depositBillRecordUuid));
                          }

                          this.preSaleOrderMainVOList.forEach((item) => {
                              this.depositBillRecordUuidArray.push(item.depositBillRecordUuid);
                              this.totalMainMoney += item.totalFee;
                          });
                      } else {
                          this.emptyFlag = true;
                          this.allFlag = false;
                          this.titleFlag = false;
                      }
                  }
              });
          },
          showContract(depositBillVo) {
              this.isCheckContract = true;
              let cartItems = [];
              depositBillVo.orderItmeList.forEach(e => {
                  if (e.productCode) {
                      cartItems.push({
                          productUuid: '',
                          brandName: '',
                          productName: e.productName,
                          unitName: e.unitName,
                          productCode: e.productCode,
                          displayPrice: e.preSalePlanPrice,
                          orderQuantity: e.orderQuantity,
                          sendDate: depositBillVo.sendProductDate
                      });
                  }
              });
              api.webGetContract({
                  items: cartItems,
                  depositBillRecordUuid: depositBillVo.depositBillRecordUuid
              }).then(res => {
                  if (res.code === 0) {
                      this.contractPath = res.data.url;
                      let url = api.downLoadServer + res.data.url.replace(/\\/g, '\/');
                      window.open(url, '_blank');
                  } else {
                      this.$bvModal.msgBoxOk("生成合同失败，请联系客户经理！", {
                          title: '提示',
                          buttonSize: 'sm'
                      });
                  }
              });
          },
    submit(){
      this.preSaleOrderMainVOList.forEach(e =>{
        this.customerMsgArray.push(e.customerMsg)
      })
    },
          // 支付订金
          payDeposit() {
              if (!this.isCheckContract) {
                  this.$bvModal.msgBoxOk("请先查看种苗定购协议！", {
                      title: '提示',
                      buttonSize: 'sm'
                  });
                  return;
              }

              //判断当前小计里是否有0的订单，如果有，则提示要去除
              let zeroSign = false;
              this.preSaleOrderMainVOList.forEach((item) => {
                  if (item.totalFee == 0) {
                      zeroSign = true;
                      return;
                  }
              });
              if (zeroSign) {
                  this.$bvModal.msgBoxOk("产品金额不能为0，请取消相应的产品！", {
                      title: '提示',
                      buttonSize: 'sm'
                  });
                  return;
              }
              if(this.clickRepeat){
                  return;
              }
              this.clickRepeat=true;
      this.submit();
      this.depositValueArray=[];
      this.preSaleOrderMainVOList.forEach(main =>{
        main.orderItmeList.forEach(item =>{
          if(item.productCode=='定金收取(%)'){
            this.depositValueArray.push(item.totalMoney);
            console.log(item.totalMoney);
          }
        });
      });
              api.webPreSaleDepositPayWithFund({
                  depositBillRecordUuidArray: this.depositBillRecordUuidArray,depositValueArray:this.depositValueArray,customerMsgArray:this.customerMsgArray,
                  orderType: 'DEPOSIT'
              }).then(res => {
                  this.clickRepeat=false;
                  if (res.code === 0) {
                      this.$bvModal.msgBoxOk("支付定金成功，现跳转至定金单。", {
                          title: '提示',
                          buttonSize: 'sm'
                      });
                      let that = this;
                      setTimeout(function() {
                          that.$router.push({
                              path: "/member/deposit-list"
                          });
                      }, 1000);
                  }
              });
          },        
          // 全额支付
          payTotalFee() {
              if (!this.isCheckContract) {
                  this.$bvModal.msgBoxOk("请先查看种苗定购协议！", {
                      title: '提示',
                      buttonSize: 'sm'
                  });
                  return;
              }
              //判断当前小计里是否有0的订单，如果有，则提示要去除
              let zeroSign = false;
              this.preSaleOrderMainVOList.forEach((item) => {
                  if (item.totalFee == 0) {
                      zeroSign = true;
                      return;
                  }
              });
              if (zeroSign) {
                  this.$bvModal.msgBoxOk("产品金额不能为0，请取消相应的产品！", {
                      title: '提示',
                      buttonSize: 'sm'
                  });
                  return;
              }
              if(this.clickRepeat){
                  return;
              }
              this.clickRepeat=true;
              //判断当前是否已有选择定金单，一个都没有选择不能支付
      this.submit()
              api.webPreSaleDepositPayWithFund({
                  depositBillRecordUuidArray: this.depositBillRecordUuidArray,customerMsgArray:this.customerMsgArray,
                  orderType: 'TOTALMONEY'
              }).then(res => {
                  this.clickRepeat=false;
                  if (res.code === 0) {
                      this.$bvModal.msgBoxOk("全额支付成功，现跳转至发货单。", {
                          title: '提示',
                          buttonSize: 'sm'
                      });
                      let that = this;
                      setTimeout(function() {
                          that.$router.push({
                              path: "/delivery-list/delivery-list"
                          });
                      }, 1000);
                  }
              });

          }

      }
  }
</script>

<style>
  .cart-address {
      padding: 10px;
      background-color: #f3f3f3;
      font-size: 16px;
      border-radius: 6px;
  }

  .address-btn {
      display: flex;
      justify-content: flex-end;
      height: 38px;
      line-height: 38px;
  }

  .cart-wrap .row {
      margin-right: 0px !important;
      margin-left: 0px !important;
      align-items: center;
  }

  .cartInfo-wrap {
      padding-left: 0px;
      padding-right: 0px;
  }

  .cart-wrap .address-btn .btn-secondary {
      background-color: #00b151 !important;
      border: #00b151 !important;
      font-size: 16px !important;
  }

  .cart-wrap .span {
      font-size: 20px;
      font-weight: bold;
  }

  .cart-wrap .form-text {
      margin-top: 0px !important;
  }

  .cart-wrap .cart-info {
      margin-top: 20px;
      width: 100%;
  }

  .cart-wrap .order-info {
      display: flex;
      align-items: center;
      padding: 5px 0px;
      border: 1px solid #dbdbdb;
      border-bottom: none;
  }

  .order-pro-list {
      position: relative;
      padding: 10px 0px;
      display: flex;
      justify-content: flex-end;
      background-color: #f7f7fb;
  }
.order-remarks {
    position: relative;
    padding: 10px 0px;
    display: flex;
    justify-content: flex-start;
    background-color: #f7f7fb;
}

  .all-select {
      position: absolute;
      left: 0px;
      top: 20px;
  }

  .order-pro-list .bf-text {
      font-weight: bold;
      font-size: 16px;
      color: #212529;
      opacity: 1;
      border: 0 !important;
      padding-left: 20px;
  }

  .order-pro-list .red-color {
      font-weight: bold;
      color: #ec4040;
      padding-right: 25px;
      font-size: 22px;
  }

  .cart-wrap .bottom-card {
      display: flex;
      align-items: center;
      padding: 5px 0px;
      background-color: #f7f7fb;
      margin-top: 20px;
      border-radius: 6px;
      position: relative;
  }

  .table.b-table[aria-busy="true"] {
      opacity: 1 !important;
  }

  .cart-info-wrap {
      padding: 0px !important;
  }

  .addres-card {
      margin-bottom: 20px;
      border: 0 !important;
      border-bottom: 1px solid #ccc !important;
  }

  .cart-wrap .table-bordered td,
  .cart-wrap .table-bordered th {
      border: 1px solid #DBDBDB;
  }

  .btns {
      display: flex;
      justify-content: flex-end;
      padding: 20px 0px;
  }

  .btns .btn {
      margin-right: 10px;
  }

  .cart-order-info .row {
      margin-right: 0px;
      margin-left: 0px;
  }


  .custom-control-input:checked~.custom-control-label::before {
      background-color: #00b151 !important;
      border: #00b151 !important;
  }

  .table-bordered thead td,
  .table-bordered thead th {
      text-align: center !important;
  }

  .table-bordered td,
  .table-bordered th {
      text-align: center !important;
  }
</style>



// WEBPACK FOOTER //
// src/view/member/order-confirm.vue